import {
  SEARCH_OVERSEAS_ON_LOAD,
  SEARCH_OVERSEAS_ON_LOAD_SUCCESS,
  SEARCH_OVERSEAS_FILTER,
  SEARCH_OVERSEAS_FILTER_SUCCESS,
  SEARCH_OVERSEAS_RESET,
  SEARCH_OVERSEAS_DETAILS_SUCCESS,
  SEARCH_OVERSEAS_DETAILS_RESET
} from './actions';

const initialState = {
  selectLoad: false,
  selectData: null,
  filterData: null,
  params: null,
  detailsData: null
}

export function searchOverseasReducer(state = initialState, action) {
  let data = action.payload;

  switch (action.type) {
    case SEARCH_OVERSEAS_ON_LOAD:
      return {
        ...state,
        selectLoad: false
      }

    case SEARCH_OVERSEAS_ON_LOAD_SUCCESS:
      return {
        ...state,
        selectData: data,
        selectLoad: true
      }

    case SEARCH_OVERSEAS_FILTER:
      return {
        ...state,
        params: data
      }

    case SEARCH_OVERSEAS_FILTER_SUCCESS:
      return {
        ...state,
        filterData: data
      }

    case SEARCH_OVERSEAS_RESET:
      return {
        selectLoad: false,
        selectData: null,
        filterData: null,
        params: null,
        detailsData: null
      }

    case SEARCH_OVERSEAS_DETAILS_SUCCESS:
      return {
        ...state,
        detailsData: data
      }

    case SEARCH_OVERSEAS_DETAILS_RESET:
      return {
        ...state,
        detailsData: null
      }

    default:
      return state;
  }
}
